export const GENERATE_LEX_LINK = 'GENERATE_LEX_LINK';
export const LEX_GENERATELINK_SUCCESS = 'LEX_GENERATELINK_SUCCESS';
export const LEX_GENERATELINK_ERROR = 'LEX_GENERATELINK_ERROR';
